import React from "react";
import TerminalInput from "./TerminalInput.jsx";

const PromptDisplay = ({
  currentPrompt,
  promptLabel,
  inputRef,
  onSubmit,
  onKeyDown,
  onFocus,
  onBlur,
  isLoading,
  isTypingPrompt,
  theme,
  inputStyle,
  terminalTextStyle,
}) => {
  // Show the prompt if we have content OR if we're currently typing it
  if (currentPrompt || isTypingPrompt) {
    const promptContent = currentPrompt || "";
    const promptLines = promptContent.split("\n");
    const lastPromptLine = promptLines.pop();
    const multilinePart = promptLines.join("\n");

    return (
      <>
        {multilinePart && (
          <div style={{ whiteSpace: "pre-wrap", ...terminalTextStyle }}>
            {multilinePart}
          </div>
        )}
        <TerminalInput
          inputRef={inputRef}
          onSubmit={onSubmit}
          onKeyDown={onKeyDown}
          onFocus={onFocus}
          onBlur={onBlur}
          isLoading={isLoading}
          promptText={lastPromptLine}
          promptColor={theme.successColor}
          inputStyle={inputStyle}
          terminalTextStyle={terminalTextStyle}
        />
      </>
    );
  }

  return (
    <TerminalInput
      inputRef={inputRef}
      onSubmit={onSubmit}
      onKeyDown={onKeyDown}
      onFocus={onFocus}
      onBlur={onBlur}
      isLoading={isLoading}
      promptText={promptLabel}
      promptColor={theme.promptColor}
      inputStyle={inputStyle}
      terminalTextStyle={terminalTextStyle}
    />
  );
};

export default PromptDisplay;
